module.exports = __webpack_public_path__ + "static/ghost-of-the-seas-ii_closeup-3c1cd0a1b36c3567cecbe618eb7fc4a7.jpg";